import React from 'react';
import classnames from 'classnames/bind';
import { string, number, bool, func } from 'prop-types';

import { withMediaQuery } from 'common/utils';
import CarouselPagination from 'elements/Pagination/CarouselPagination/CarouselPagination';
import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';
import Button from 'elements/Buttons/Button';

import styles from './CarouselPage.css';

const cx = classnames.bind(styles);

const CarouselPage = ({
  autoplay,
  carouselHandler,
  totalPages,
  currentPage,
  leftSide,
  label,
  highlighted,
  title,
  description,
  onButtonClick,
  buttonText
}) => {
  const mediaQueryButtons = [
    {
      onClick: onButtonClick,
      classes: 'secondary large black',
      children: buttonText,
      minWidth: 1366
    },
    {
      onClick: onButtonClick,
      classes: 'secondary small black',
      children: buttonText,
      minWidth: 480,
      maxWidth: 1365
    }
  ];

  return (
    <div className={cx('page', { 'leftSide': leftSide })}>
      <div className={styles.container}>

        <p className={styles.flag}>{label}</p>
        <h5 className={styles.title}>
          {highlighted && <span className={styles.highlight}>{highlighted} </span>}
          {title}
        </h5>
        <p className={styles.description}>{description}</p>

        <div className={styles.button}>
          {withMediaQuery(Button, mediaQueryButtons)}
          <LinkFreeStanding className={styles.link} medium onClick={onButtonClick} size="xs">
            {buttonText}
          </LinkFreeStanding>
        </div>

        <div className={styles.carousel}>
          <CarouselPagination
            totalItems={totalPages}
            currentPage={currentPage}
            autoplay={autoplay}
            onPageChange={carouselHandler}
            medium
          />
        </div> 
      </div>
    </div>
  );
};

CarouselPage.propTypes = {
  autoplay: bool,
  totalPages: number,
  currentPage: number,
  carouselHandler: func,
  leftSide: bool,
  label: string,
  highlighted: string,
  title: string,
  description: string,
  onButtonClick: func,
  buttonText: string
};

CarouselPage.displayName = 'CarouselPage';

export default CarouselPage;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/CarouselBanner/CarouselPage/CarouselPage.js